const oidc = {
    logout_success: 'Hai effettuato il logout correttamente.',
};
export default oidc;
